<template>
  <div class="twui-markbox" style="margin-top:15px" v-if="$store.state.hasDoc">
    <div class="search">
      <div class="searchbox">
        <el-input @keyup.enter.native="toSearch" v-model="$store.state.searchKey" :placeholder="$t('m.input_key')"></el-input>
        <i class="twui-ico xsearch" @click="toSearch"></i>
      </div>
    </div>
    <!-- 标题和上传功能按钮等 -->
    <h2 class="tit">{{doc.docTitle}}</h2>
    <div class="operate">
      <span class="time">{{$t('m.update_time')}}：{{doc.lastModifyTime}}</span>
      <div class="right">
        <!-- v-if=" $store.state.typeOfAppList.length===0&&$store.state.isAdmin && !editor.isEditing" -->
        <a v-if=" $store.state.typeOfAppList.length===0&&$store.state.isAdmin && !editor.isEditing" @click="editorDoc">
          <i class="twui-ico xedit"></i>
          {{$t('m.editor')}}
        </a>
        <!-- v-else -->
        <div v-else class="editcon">
          <div v-if="$store.state.isAdmin && editor.isEditing" class="twui-ico xtips">
            <div class="info">{{$t('m.support_file_type_info')}}</div>
          </div>
          <el-upload
            v-if=" $store.state.isAdmin && editor.isEditing"
            :action="file_upload_server"
            :headers="headerObj"
            :data="uploadData"
            class="xuploadbtn"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :before-upload="beforeUpload"
            :show-file-list="false"
            :accept="fileType"
          >
            <button class="twui-btn xborder">{{$t('m.upload_file')}}</button>
          </el-upload>
          <button v-if=" $store.state.isAdmin && editor.isEditing" class="twui-btn xborder" @click="cancelSave">{{$t('m.cancle')}}</button>
          <button v-if=" $store.state.isAdmin && editor.isEditing" class="twui-btn xmain" @click="saveDoc">{{$t('m.save')}}</button>
        </div>
      </div>
    </div>
    <div style="margin-top:15px">
      <tw-markdown-view v-if="!editor.isEditing" ref="markdownView"></tw-markdown-view>
      <tw-markdown-editor v-if="editor.isEditing" ref="markdown"></tw-markdown-editor>
    </div>
  </div>
  <div v-else>
    <div class="nodata-box">
      <img src="../../static/images/nodata.png" alt />
      <span>{{$t('m.zwwd')}}</span>
    </div>
  </div>
</template>

<script>
import TwMarkdownEditor from '../../components/tw-markdown-editor'
import TwMarkdownView from '../../components/tw-markdown-view'
import utils from '@/config/cookieUtils'
// import { util } from 'vue/types/umd'
export default {
  name: 'twMarkdown',
  components: { TwMarkdownEditor, TwMarkdownView },
  data: function () {
    return {
      file_upload_server: this.$store.state.gateway_url + '/fs/fs/file/upload',
      headerObj: {
        'Access-Token': this.$store.state.token
      },
      fileType:
        'image/jpeg,mage/jpg,image/gif,image/png,image/bmp,video/mp4,video/avi,doc,docx,xls,xlsx,ppt,pptx',
      uploadData: {
        branchCode: this.$store.state.tenantId
          ? this.$store.state.tenantId
          : 'PAAS01'
      },
      doc: {},
      titleTimer: null,
      editor: this.$store.state.editor
    }
  },
  methods: {
    cancelSave: function () {
      this.editor.isEditing = !this.editor.isEditing
    },
    toSearch: function () {
      let vm = this
      if (vm.$store.state.searchKey) {
        this.$store.commit('changePageName', 'twDocSearch')
      }
      console.log(this.$store.state.pageName)
    },
    beforeUpload: function (file) {
      // var fileName = file.name
      // if (this._.trim(fileName) === '' ||
      //   !this._.endsWith(fileName, '.xls')) {
      //   this.$message.error(this.$i18n.messages[this.$i18n.locale].m.selectCorrctExcelFile)
      //   return false
      // }
      // alert(1)
    },

    uploadFail: function (err) {
      console.log(err)
      this.$message.error('上传文件失败')
    },
    //  上传成功
    uploadSuccess: function (rep) {
      if (rep.fileInfos != null && rep.fileInfos.length > 0) {
        let vm = this
        let filePath = rep.fileInfos[0].localPath
        if (filePath) {
          let fileUrl = vm.$store.state.gateway_url + '/fs/media' + filePath
          let mdUrl = null
          let markdown = vm.$refs['markdown']
          if (vm.isImage(filePath)) {
            mdUrl = '![](' + fileUrl + ')'
          } else if (vm.isVideo(filePath)) {
            mdUrl = `<video src="${fileUrl}" controls="controls" width="500" height="300">您的浏览器不支持播放该文件！</video>`
          } else {
            mdUrl = fileUrl
          }
          let newMd = markdown.getMarkdown() + '\n' + mdUrl
          markdown.setMarkdown(newMd)
          markdown.watch()
        }
      }
    },
    isImage: function (filePath) {
      if (
        this._.endsWith(filePath, '.jpg') ||
        this._.endsWith(filePath, '.jpeg') ||
        this._.endsWith(filePath, '.png') ||
        this._.endsWith(filePath, '.bmp') ||
        this._.endsWith(filePath, '.gif')
      ) {
        return true
      }
      return false
    },
    isVideo: function (filePath) {
      if (
        this._.endsWith(filePath, '.mp4') ||
        this._.endsWith(filePath, '.avi') ||
        this._.endsWith(filePath, '.wmv') ||
        this._.endsWith(filePath, '.m4v')
      ) {
        return true
      }
      return false
    },
    editorDoc: function () {
      let vm = this
      vm.toggleEdit()
    },
    toggleEdit: function () {
      this.editor.goEdit = true
      this.editor.isEditing = !this.editor.isEditing
    },
    saveDoc: function () {
      let vm = this
      let markdown = vm.$refs['markdown']
      let md = markdown.getMarkdown()
      let doc = vm.doc
      doc.content = md
      vm.axios
        .post('/openapi-uc/doc/updateDocument', vm.doc)
        .then(function (response) {
          vm.toggleEdit()
        })
        .catch(function (error) {
          vm.$message({
            message: error.data.serverResult.resultMessage,
            type: 'error'
          })
          console.log(error)
        })
    },
    setViewDoc: async function (id) {
      let vm = this
      let markdownView = vm.$refs['markdownView']
      if (id === '' || id === undefined || id.length === 0) {
        return
      }
      vm.axios
        .get('/openapi-uc/doc/getDocById/' + id)
        .then(function (response) {
          vm.doc = response.data.pageInfo.list[0]
          try {
            markdownView.setDoc(vm.doc)
          } catch (e) {
            console.log(e)
          }
        })
        .catch(function (error) {
          vm.$message({
            message: error.data.serverResult.resultMessage,
            type: 'error'
          })
          console.log(error)
        })
    },
    getIsAdmin () {
      for (let a of this.$store.state.MenuList3th) {
        if (a.children && a.children.length > 0) {
          for (let b of a.children) {
            if (b.creatorId === utils.get('Current_User_Id')) {
              this.$store.commit('areYouAdmin', true)
            } else {
              this.$store.commit('areYouAdmin', false)
            }
          }
        } else {
          if (a.creatorId === utils.get('Current_User_Id')) {
            this.$store.commit('areYouAdmin', true)
          } else {
            this.$store.commit('areYouAdmin', false)
          }
        }
      }
    }
  },
  // 改版关键
  watch: {
    MenuId: {
      deep: true,
      immediate: true,
      handler (val) {
        this.$nextTick(() => { this.setViewDoc(val) })
        if (this.editor.isEditing) {
          this.cancelSave()
        }
        this.getIsAdmin()
      }
    }
  },
  mounted: function () {
    let vm = this
    vm.titleTimer = setInterval(function () {
      if (!vm.doc || !vm.doc.title) {
        let markdownView = vm.$refs['markdownView']
        if (markdownView) {
          let doc = markdownView.getDoc()
          if (doc) {
            vm.doc = doc
            if (vm.doc.docTitle) {
              let roleIdList = utils.get('CURRENT_ROLE_ID_LIST')
              if (roleIdList && roleIdList.length > 0) {
                if (
                  roleIdList.indexOf('1000000001') >= 0 ||
                  roleIdList.indexOf('1000000005') >= 0
                ) {
                  vm.editor.isAdmin = true
                } else {
                  vm.editor.isAdmin = false
                }
              } else {
                vm.editor.isAdmin = false
              }
              window.clearInterval(vm.titleTimer)
              vm.titleTimer = null
            }
          }
        }
      } else {
        window.clearInterval(vm.titleTimer)
        vm.titleTimer = null
      }
    }, 80)
  },
  computed: {
    MenuId () {
      return this.$store.state.MenuId
    }
  },
  destroyed: function () {
    let vm = this
    if (vm.titleTimer != null) {
      window.clearInterval(vm.titleTimer)
      vm.titleTimer = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?06b397bf